<template>
    <div class="bg-white full-height d-flex align-items-center">
     <CRow class="p-2">
        <CCol sm="6">
            <img src="../assets/image/bg-Login.png" style="max-width:100%"/>
        </CCol>
        <CCol sm="6">
                <div class="custom-form-bg text-left d-flex justify-content-center margin-top-15">
                    <h3 class="font-color-101828 text-left custom-24px-600">Welcome Back Again</h3>
                    <p class="font-color-98A2B3 text-left custom-16px-400">Login to your account</p>
                    <label class="font-color-171717 text-left custom-16px-400">Email</label>
                    <input type="text" class="custom-bg-btn-white-border" v-model="userEmail"/>
                    <label class="font-color-171717 text-left mt-3">Password</label>
                    <input type="password" class="custom-bg-btn-white-border" v-model="userPassword"/>
                    <label class="text-right font-color-7F56D9 mt-3">Forgot Password?</label>
                    <CButton type="button" class="custom-default-btn bg-7F56D9 text-white mt-3 border-16px" v-on:click="trylogin">Login</CButton>
                    <CButton type="button" class="bg-white custom-bg-btn-white-border custom-default-btn mt-3"><img src="../assets/image/Google-Icon.png" width="24px" class="mr-2"/>Login with Google</CButton>
                    <p class="custom-14px-400 font-color-98A2B3 text-center mt-3">Dont have account? <strong class="font-color-7F56D9" @click="GoToSignUp()">Sign Up</strong></p>
                </div>
        </CCol>
     </CRow>
    
    </div>
</template>


<script>
import Vue from "vue";


import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
         




          
            userEmail: "",
            userPassword: "",



        };
    },
    created() {
      
    },


    methods: {
        

        trylogin() {
            this.ErrorLogin = false;

            const formData = new FormData();

            if (this.userEmail === "" || this.userPassword === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("Email", this.userEmail);
                formData.append("Password", this.userPassword);

                this.$API
                    .post(this.$LoginToken, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.ErrorLogin = true;
                        }
                        if (response.status == 200) {

                            if (response.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    //  const userId = response.data.data.userType;
                                    // console.log("userid", userId);
                                    if (response.data.data.userType === '-') {
                                        this.$router.push("Profile");
                                    } else if (response.data.data.userType === 'individual') {
                                        this.$router.push("Profile");
                                    } else {
                                        this.$router.push("Dashboard");
                                    }

                                }
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.ErrorLogin = true;
                            }
                        } else {
                            this.Loading = false;
                            this.ErrorLogin = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.ErrorLogin = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        registerAccount() {

            const formData = new FormData();

            if (this.Name === "" || this.Email === "" || this.Phone === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.selectedUser);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);




                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    this.isLanguagePopupVisible1 = true;
                                }


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Dashboard");
        },
        async login() {
            this.lblGoogle = "Google";
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());



                
                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    var authResponse = googleuser.getAuthResponse();
            var accessToken = authResponse.access_token;
            var idToken = authResponse.id_token;

            console.log('ID Token:', idToken);
            console.log('Access Token:', accessToken);

            // Verify if the token includes the scope
            await this.verifyScopes(accessToken);

            // Fetch user phone and address info
            const userInfo = await this.getUserInfo(accessToken);
            console.log('User Info:', userInfo);

            const userName = userInfo.displayName;
                    this.getUserEmail(idToken, userName);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
       
        GoToSignUp()
        {
            this.$router.push("SignUp");

        },
      

    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>